<template>
  <div class="group_box" v-loading="loading2"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.6)">
    <div class="head_box">
      <div></div>
      <div class="select_box">
        <div class="select_item">
          <span class="title">学院范围</span>
          <el-select
            v-model="collegeData"
            collapse-tags
            placeholder="请选择"
            multiple
            @change="unitChange()"
          >
            <el-option
              v-for="item in college"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </div>
        <div class="select_item">
          <span class="title">年级范围</span>
          <el-select
            v-model="entryYearData"
            multiple
            collapse-tags
            placeholder="请选择"
            @change="unitChange()"
          >
            <el-option
              v-for="item in entryYear"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </div>
        <div class="select_item">
          <el-input v-model="serchValue" placeholder="姓名、学号"></el-input>
          <div class="search" @click="onSearch">搜索</div>
        </div>
      </div>
    </div>
    <div class="body_box">
      <div class="top_box">
        <!-- 应符 -->
        <div class="yf_box">
          <div class="box-tit">
            <span></span><b>应符</b
            ><span>应符合社会主义核心价值观（平均值）</span>
          </div>
          <div class="box-content">
            <img
              class="img1"
              src="https://univteam-imageserver.oss-cn-qingdao.aliyuncs.com/ClassMS/Images/202110211136274053.png"
              alt=""
            />
            <img
              src="https://univteam-imageserver.oss-cn-qingdao.aliyuncs.com/ClassMS/Images/202110211135469852.png"
              alt=""
              class="img2"
            />
            <div
              id="myChart"
            ></div>
          </div>
        </div>
        <div class="yh_box">
          <div class="box-tit">
            <span></span><b>应会</b
            ><span>应训练的个人技能（平均值）</span>
          </div>
          <div class="yh_tit">
            共点亮才能<span>{{ total }}</span>
          </div>
          <div
            class="item_box scrollT"
            v-infinite-scroll="getGroupSkill"
            infinite-scroll-disabled="disabled"
          >
            <div class="item" v-for="(item, index) in skillList" :key="index">
              <div>{{ item.skill }}</div>
              <div>
                <span>{{ item.userCount }}人</span
                ><span>{{ item.percent }}%</span>
              </div>
            </div>
            <p v-if="loading" class="loading_one">加载中...</p>
            <p v-if="noMore" class="loading_one">没有更多了</p>
          </div>
        </div>
      </div>
      <div class="center_box">
        <!-- 应能 -->
        <div class="yn_box">
          <div class="box-tit">
            <span></span><b>应能</b><span>应具备的必要能力素养（平均值）</span>
          </div>
          <div class="box-content">
            <div class="symbol_box">
              <div>评估时间：{{time}}</div>
              <div style="margin-left: 60px">
                <img
                  src="https://oss2.iouke.cn/growth_log/imgbg/2021/10/18/85091fa29191913cdbe700914f1e7993.png"
                  alt=""
                />
                <span>平均值</span>
              </div>
              <div style="margin-left: 30px">
                <img
                  src="https://oss2.iouke.cn/growth_log/imgbg/2021/10/18/fbf0797ad4a4cb8a113790aa4388ce73.png"
                  alt=""
                />
                <span>最高值</span>
              </div>
            </div>
            <div id="ynEcharts" style="height: 100%; width: 100%"></div>
          </div>
        </div>
      </div>
      <!-- 底部 -->
      <div class="bottom_box">
        <!-- 应会 -->
        <!-- <div class="yh_box">
          <div class="box-tit">
            <span></span><b>应会</b
            ><span>应符合社会主义核心价值观（平均值）</span>
          </div>
          <div class="yh_tit">共点亮才能<span>129</span></div>
          <div class="item_box scrollT">
            <div class="item">
              <div>ppt</div>
              <div><span>865人</span><span>26.0%</span></div>
            </div>
          </div>
        </div> -->
        <!-- 应备 -->
        <!-- <div class="yh_box" style="margin-right: 0">
          <div class="box-tit">
            <span></span><b>应备</b><span>3321名学生的资格证书与荣誉统计</span>
          </div>
          <div class="yh_tit">
            资格证书<span>56</span
            ><b style="font-weight: inherit; margin-left: 48px">荣誉证书</b
            ><span>256</span>
          </div>
          <div class="item_box scrollT">
            <div class="item">
              <div>教师资格证 中学</div>
              <div><span>865人</span><span>26.0%</span></div>
            </div>
          </div>
        </div> -->
      </div>
      <el-dialog title="选人" :visible.sync="dialogVisible" width="30%">
        <div class="choose_people">
          <div
            :class="['choose_item', { active: active == index }]"
            v-for="(item, index) in userList"
            :key="index"
            @click="choosePeople(index, item.uid)"
          >
            <img :src="item.avatarUri" alt="" />
            <span>{{ item.name }}</span>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="
              dialogVisible = false;
              uids = '';
            "
            >取 消</el-button
          >
          <el-button type="primary" @click="choosePeopleDefine()"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {EleResize} from '../../../static/esresize'
export default {
  data() {
    return {
      dialogVisible: false,
      value: "",
      serchValue: "",
      college: [{ key: 0, value: "全部学院" }],
      collegeData: [0],
      entryYearData: [0],
      entryYear: [{ key: 0, value: "全部年级" }],
      pageIndex: 1,
      pageSize: 9,
      skillList: [],
      total: 0,
      loading: false,
      loading2:false,
      uids: "",
      userList: [],
      active: -1,
      lineEcharts:null,
      barEcharts:null,
      time:'2020年9月20日',
      echartData:[],
    };
  },
  computed: {
    noMore() {
      return this.count >= this.total;
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  mounted() {
    this.loading2=true;
    this.getdropdown();
    this.getflyWheel();
    this.getGroupSkill();
    this.getGroupAbility();
  },
  watch: {
    collegeData: function (val, oldval) {
      let newIndex = val.indexOf(0),
        oldIndex = oldval.indexOf(0);
      if (newIndex != -1 && oldIndex == -1 && val.length > 1) {
        this.entryYearData = [0];
      } else if (newIndex != -1 && oldIndex != -1 && val.length > 1) {
        this.entryYearData.splice(val.indexOf(0), 1);
      }
    },
    entryYearData: function (val, oldval) {
      let newIndex = val.indexOf(0),
        oldIndex = oldval.indexOf(0);
      if (newIndex != -1 && oldIndex == -1 && val.length > 1) {
        this.entryYearData = [0];
      } else if (newIndex != -1 && oldIndex != -1 && val.length > 1) {
        this.entryYearData.splice(val.indexOf(0), 1);
      }
    },
  },
  methods: {
    unitChange(){
        this.loading2=true;
        this.pageIndex=1;
        this.getflyWheel();
        this.getGroupSkill();
        this.getGroupAbility();
    },
    choosePeople(index, uid) {
      this.active = index;
      this.uids = uid;
    },
    choosePeopleDefine() {
      if (this.active != -1) {
        this.dialogVisible=false;
        this.loading2=true;
        this.pageIndex=1;
        this.getflyWheel();
        this.getGroupSkill();
        this.getGroupAbility();
      }else{
        this.$alert('请选择用户！')
      }
    },
    //获取下拉框信息
    getdropdown() {
      this.$api.common.getdropdown().then((res) => {
        if (res.data.statusCode == 200) {
          res.data.data.college.forEach((element) => {
            this.college.push(element);
          });
          res.data.data.entryYear.forEach((element) => {
            this.entryYear.push({ key: element, value: element });
          });
        } else {
          this.$alert(res.data.errors);
        }
      });
    },
    //获取用户列表
    getGroupUsers() {
      let params = {
        blurryInfo: this.serchValue,
        data: { uids: this.uids == "" ? [] : [this.uids] },
      };
      this.loading2=true;
      this.$api.common.getGroupUsers(params).then((res) => {
        if (res.data.statusCode == 200) {
          if (res.data.data.length > 0) {
            this.dialogVisible = true;
            this.userList = res.data.data;
          } else {
            this.$alert('没有检索到该用户')
          }
        } else {
          this.$alert(res.data.errors);
        }
        this.loading2=false;
      });
    },
    //获取飞轮图
    getflyWheel() {
      let params = {
        colleges: this.collegeData.indexOf(0) != -1 ? [] : this.collegeData,
        entryYears:
          this.entryYearData.indexOf(0) != -1 ? [] : this.entryYearData,
        data: { uids: this.uids == "" ? [] : [this.uids] },
      };
      this.$api.common.getflyWheel(params).then((res) => {
        if (res.data.statusCode == 200) {
          console.log(res.data.data);
          this.drawFeilun(res.data.data);
        } else {
          this.$alert(res.data.errors);
        }
        this.loading2=false;
      });
    },
    //获取应能
    getGroupAbility() {
      let _this= this;
      let params = {
        colleges: this.collegeData.indexOf(0) != -1 ? [] : this.collegeData,
        entryYears:
          this.entryYearData.indexOf(0) != -1 ? [] : this.entryYearData,
        data: { uids: this.uids == "" ? [] : [this.uids] },
      };
      this.$api.common.getGroupAbility(params).then((res) => {
        if (res.data.statusCode == 200) {
          this.echartData=res.data.data.chart;
          let myPowerVal = [],
            myPowerName = [],
            pingjunzhi = [];
          this.time=res.data.data.time;
          res.data.data.chart.forEach((el) => {
            myPowerVal.push(el.levelAvg);
            myPowerName.push(el.ability);
            pingjunzhi.push(el.levelMax);
          });
          // 画图
          setTimeout(()=>{
              _this.drawbar(myPowerVal, myPowerName, pingjunzhi);
          },500)
          
        }
        this.loading2=false;
      });
    },
    //获取应会
    getGroupSkill() {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        data: {
          colleges: this.collegeData.indexOf(0) != -1 ? [] : this.collegeData,
          entryYears:
            this.entryYearData.indexOf(0) != -1 ? [] : this.entryYearData,
          uids: this.uids == "" ? [] : [this.uids],
        },
      };
      if (this.pageIndex == 1) {
        this.skillList = [];
      }
      this.loading = true;
      this.$api.common.getGroupSkill(params).then((res) => {
        if (res.data.statusCode == 200) {
          this.pageIndex++;
          res.data.data.list.forEach((element) => {
            this.skillList.push(element);
          });
          this.total = res.data.data.total;
        } else {
          this.$alert(res.data.errors);
        }
        this.loading = false;
      });
    },
    //搜索
    onSearch() {
      if (this.serchValue == "") {
        this.active = -1;
        this.uids = "";
        this.$alert("请输入姓名、学号");
        return;
      }
      this.getGroupUsers();
    },
    //折线图
    drawFeilun(feilun) {
      let _this=this;
      _this.lineEcharts = this.$echarts.init(document.getElementById("myChart"));
      let arr = [],
        arrMax = [];
      feilun.forEach((element) => {
        arr.push(Number(element.value));
        arrMax.push({ max: Number(element.max) });
      });
       _this.lineEcharts.setOption({
        radar: {
          // shape: 'circle',
          startAngle: 129.5,
          center: ["50%", "50%"],
          radius: ["69px", "120px"],
          //  radius: ["20%", "90%"],
          // radius:['80%','80%'],
          name: {
            textStyle: {
              color: "#fff",
              backgroundColor: "#fff",
              borderRadius: 3,
              padding: [3, 5],
            },
          },
          indicator: arrMax,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          splitArea: {
            show: false,
          },
        },
        series: [
          {
            type: "radar",
            symbol:
              "image://https://oss2.iouke.cn/growth_log/imgbg/2021/8/16/03807c9716204c1aec6bda2a6bbb2ce6.png",
            symbolSize: 6,
            lineStyle: {
              color: "#A3A3A3",
              type: "dashed",
              width: 1,
            },
            areaStyle: {
              color: "rgba(167,167,167,0.28)",
            },
            data: [
              {
                value: arr,
                // value:[7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
                // value:[7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7]
              },
            ],
          },
        ],
      });
      // window.onresize = function () {
      //   // _this.barEcharts.resize();
      //   _this.lineEcharts.resize();
      // };
      let echartsid = document.getElementById("myChart")
      let listener = function(){
        _this.lineEcharts.resize()
      }
      EleResize.on(echartsid,listener)
    },
    //柱状图
    drawbar(myPowerVal, myPowerName, pingjunzhi) {
      let _this=this;
      _this.barEcharts = this.$echarts.init(document.getElementById("ynEcharts"));
      _this.barEcharts.setOption({
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(231,104,0,.1)",
          textStyle: "#2A2E3D",
          axisPointer: {
            type: "shadow",
            shadowStyle: {
              color: "rgba(0,0,0,0)",
              shadowColor: "rgba(237,108,2,.2)",
              shadowOffsetX: 0,
              shadowOffsetY: 5,
              opacity: 1,
            },
          },
          formatter: function (params) {
            var result = "";
            var dotHtml =
              '<img  src="https://oss2.iouke.cn/growth_log/imgbg/2021/10/18/85091fa29191913cdbe700914f1e7993.png" alt="" style="display:inline-block;margin-right:5px;height:10px;width:10px;">平均值：';
            var img2 =
              '<img  src="https://oss2.iouke.cn/growth_log/imgbg/2021/10/18/fbf0797ad4a4cb8a113790aa4388ce73.png" alt="" style="display:inline-block;margin-right:5px;height:10px;">最大值：';
            result +=
              params[0].axisValue +
              "</br>" +
              dotHtml +
              params[0].value +
              "</br>" +
              img2 +
              params[1].value;
            return result;
          },
        },
        grid: {
          borderWidth: 0,
          top: 40,
          bottom: 40,
          left: 30,
          right: 10,
          textStyle: {
            color: "#fff",
          },
        },
        dataZoom: [
          {
            type: "inside",
            show: false,
            xAxisIndex: 0,
            zoomOnMouseWheel: false,
            startValue: 0,
            endValue: 20,
            zoomLock: true,
          },
        ],
        xAxis: [
          {
            type: "category",
            data: myPowerName,
            triggerEvent: true,
            splitNumber: 10,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              clickable: true,
              textStyle: {
                fontSize: 14,
                fontWeight: "bold",
                lineHeight: 18,
                color: "#7C829D",
              },
              interval: 0,
              formatter: function (params) {
                var newParamsName = "";
                var paramsNameNumber = params.length;
                var provideNumber = 2; // 每行能显示的字的个数
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                if (paramsNameNumber > provideNumber) {
                  /** 循环每一行,p表示行 */
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = ""; // 表示每一次截取的字符串
                    var start = p * provideNumber; // 开始截取的位置
                    var end = start + provideNumber; // 结束截取的位置
                    // 此处特殊处理最后一行的索引值
                    if (p == rowNumber - 1) {
                      // 最后一次不换行
                      tempStr = params.substring(start, paramsNameNumber);
                    } else {
                      // 每一次拼接字符串并换行
                      tempStr = params.substring(start, end) + "\n";
                    }
                    newParamsName += tempStr;
                  }
                } else {
                  newParamsName = params;
                }
                return newParamsName;
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                show: false,
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(220,220,220,.4)",
                type: "solid",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            max: 9,
            interval: 1,
            axisLabel: {
              textStyle: { fontSize: 14, color: "#7C829D" },
              formatter: "v{value}",
            },
            axisLine: {
              show: false,
              lineStyle: {
                show: false,
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(220,220,220,0.4)",
                type: "solid",
              },
            },
          },
        ],
        series: [
          {
            name: "我的",
            type: "bar",
            barMaxWidth: "50",
            symbol:
              "image://https://oss2.iouke.cn/growth_log/imgbg/2021/10/18/fbf0797ad4a4cb8a113790aa4388ce73.png",
            data: myPowerVal,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  textStyle: {
                    color: "#BAC2D1",
                    fontWeight: "500",
                    fontSize: "11",
                  },
                  position: "top",
                  formatter: function (p) {
                    return p.value > 0 ? "V" + parseInt(p.value) : "";
                  },
                },
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#007F41" }, //柱图渐变色
                  { offset: 1, color: "#FFFFFF" }, //柱图渐变色
                ]),
                //柱形图圆角，鼠标移上去效果
                emphasis: {
                  barBorderRadius: [5, 5, 0, 0],
                },
                barBorderRadius: [5, 5, 0, 0],
              },
            },
          },
          {
            name: "均值",
            type: "line",
            symbol:
              "image://https://oss2.iouke.cn/growth_log/imgbg/2021/10/18/fbf0797ad4a4cb8a113790aa4388ce73.png",
            data: pingjunzhi,
            smooth: false,
            symbolSize: 10,
            itemStyle: {
              normal: {
                color: "#007F41", //改变折线点的颜色
              },
            },
            itemStyle: {
              opacity: 1,
            },
            lineStyle: {
              width: 0,
            },
          },
        ],
      });
      window.onresize = function () {
        _this.barEcharts.resize();
      };
    },
  },
};
</script>
<style scoped lang="scss">
.group_box {
  padding: 40px;
  font-size: 13px;
  .box-tit {
    display: flex;
    align-items: center;
    span:nth-child(1) {
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background: #007F41;
      margin-right: 10px;
    }
    b {
      color: #2a2e3d;
      font-size: 20px;
      margin-right: 10px;
    }
    span:nth-child(3) {
      color: #7c829d;
      font-size: 14px;
    }
  }
  .box-content {
    margin-top: 30px;
    height: 80%;
  }
  .head_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .select_box {
      display: flex;
      align-items: center;
      .select_item {
        display: flex;
        align-items: center;
        margin-left: 40px;
        position: relative;
        .search {
          background: #007F41;
          color: #fff;
          width: 69px;
          border-radius: 4px;
          height: 35px;
          text-align: center;
          line-height: 35px;
          cursor: pointer;
          position: absolute;
          right: 0;
          top: 0;
        }
      }
      .title {
        width: 72px;
        height: 35px;
        background: #fff;
        color: #7c829d;
        border-radius: 4px;
        margin-right: 4px;
        text-align: center;
        line-height: 35px;
      }
      ::v-deep .el-input--suffix .el-input__inner {
        height: 35px;
        width: 212px;
        border: none;
        color: #7c829d;
      }
      ::v-deep .el-input__inner {
        width: 312px;
        border: none;
        color: #7c829d;
        height: 35px;
      }
    }
  }
  .body_box {
    margin-top: 50px;
    .center_box {
      width: 100%;
      .yn_box {
        width: 100%;
        height: 437PX;
        background: #fff;
        border-radius: 20px;
        padding: 30px;
        position: relative;
        .symbol_box {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #bac2d1;
          div {
            display: flex;
            align-items: center;
            img {
              width: 15px;
              margin-right: 11.2px;
            }
          }
        }
      }
    }
    .top_box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 30px;
      .yf_box {
        width: 50%;
        height: 437PX;
        background: #fff;
        margin-right: 30px;
        border-radius: 20px;
        padding: 30px;
        position: relative;
        .box-content {
          height: 320PX;
          position: relative;
          // height: 100%;
          .img1 {
            height: 300PX;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          .img2 {
            height: 140PX;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          #myChart {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
      .yh_box {
        width: 50%;
        background: #fff;
        border-radius: 20px;
        padding: 30px;
        height: 437PX;
        .yh_tit {
          margin-top: 36px;
          font-size: 12px;
          color: #7c829d;
          display: flex;
          align-items: center;
          padding: 0 24px;
          span {
            font-size: 20px;
            font-weight: bold;
            color: #007F41;
            margin-left: 10px;
          }
        }
        .item_box {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          height: 294PX;
          overflow: auto;
          padding: 0 24px;
          padding-bottom: 24px;
          .item {
            height: 87px;
            width: 250px;
            margin-top: 15px;
            div:nth-child(1) {
              background: rgba(0,127,65, 0.16);
              font-size: 18px;
              color: #2a2e3d;
              height: 32px;
              text-align: center;
              padding: 0 10px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              width: 100%;
              line-height: 32px;
            }
            div:nth-child(2) {
              background: rgba(0,27,65,0.05);
              font-size: 20px;
              color: #2a2e3d;
              height: 53px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 0 22px;
              span:nth-child(2) {
                color: #7c829d;
                font-size: 18px;
              }
            }
          }
        }
      }
    }
    .bottom_box {
      display: flex;
      align-items: center;
      width: 100%;
      .yh_box {
        width: 50%;
        margin-right: 30px;
        background: #fff;
        border-radius: 20px;
        padding: 30px;
        height: 420px;
        .yh_tit {
          margin-top: 36px;
          font-size: 12px;
          color: #7c829d;
          display: flex;
          align-items: center;
          padding: 0 24px;
          span {
            font-size: 20px;
            font-weight: bold;
            color: #007F41;
            margin-left: 10px;
          }
        }
        .item_box {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          height: 294px;
          overflow: auto;
          padding: 0 24px;
          padding-bottom: 24px;
          .item {
            height: 87px;
            width: 250px;
            margin-top: 15px;
            div:nth-child(1) {
              background: rgba(0, 127, 65, 0.16);
              font-size: 18px;
              color: #2a2e3d;
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            div:nth-child(2) {
              background: rgba(0, 127, 65, 0.05);
              font-size: 20px;
              color: #2a2e3d;
              height: 53px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 0 22px;
              span:nth-child(2) {
                color: #7c829d;
                font-size: 18px;
              }
            }
          }
        }
      }
    }
  }
  .loading_one {
    text-align: center;
    width: 100%;
    font-size: 14px;
    margin-top: 15px;
  }
  .choose_people {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-around;
    .choose_item {
      width: 200px;
      height: 50px;
      border-radius: 20px;
      border: 1px solid #bac2d1;
      color: #2a2e3d;
      display: flex;
      align-items: center;
      padding: 0 20px;
      cursor: pointer;
      margin-bottom: 20px;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
    .active {
      color: #007F41;
      background: rgba(237, 107, 0, 0.16);
    }
  }
}
#myChart{
  width: 270PX;
  height: 270PX;
}
.no_yndata{
 position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 26px;
    font-weight: bold;
    color: #BAC2D1;
}
</style>
